import { createSlice } from '@reduxjs/toolkit';

const audioSlice = createSlice({
  name: 'audio',
  initialState: {
    selectedMicId: localStorage.getItem('selectedMicId') || 'default',
    selectedSpeakerId: localStorage.getItem('selectedSpeakerId') || 'default',
    // Spoken language for voice/video calls, sent as `locale` in the LiveKit
    // call initiation. Defaults to the browser locale; user-overridable in the
    // Settings popover. Stored as a BCP-47 locale string (e.g. 'en-GB', 'fr-FR').
    selectedLocale:
      localStorage.getItem('selectedLocale') ||
      (typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage)) ||
      'en-US',
    // True while the AudioDevicePopover (the footer "Settings" popover) is open.
    // Used by GuidedTour to hide nudges so they never sit over the popover —
    // the popover renders inside a low stacking context (footer/call view) so a
    // z-index alone can't keep the root-level nudge beneath it.
    isAudioPopoverOpen: false,
  },
  reducers: {
    setSelectedMic(state, action) {
      state.selectedMicId = action.payload;
      localStorage.setItem('selectedMicId', action.payload);
    },
    setSelectedSpeaker(state, action) {
      state.selectedSpeakerId = action.payload;
      localStorage.setItem('selectedSpeakerId', action.payload);
    },
    setAudioPopoverOpen(state, action) {
      state.isAudioPopoverOpen = action.payload;
    },
    setSelectedLocale(state, action) {
      state.selectedLocale = action.payload;
      localStorage.setItem('selectedLocale', action.payload);
    },
  },
});

export const { setSelectedMic, setSelectedSpeaker, setAudioPopoverOpen, setSelectedLocale } = audioSlice.actions;
export default audioSlice.reducer;
